class WishlistCollection {
  constructor() {
    this.wishlistItems = [];
    this.fetchWishlistItems();
  }
  async fetchWishlistItems() {
    const customerId = await handleLogIn();
    if (!customerId) return;

    const response = await fetch(
      "https://rarewaves-wishlist.etempashopifyapps-server-i.co.uk/endpoints/retrieve_wishlist.php",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          customer_id: customerId,
        }),
      },
    );
    const data = await response.json();
    if (data.failed) {
      console.error("Error retrieving wishlist");
      throw new Error("Something went wrong retrieving your wishlist");
    } else if (!Boolean(data.wishlist_empty)) {
      //console.log(data.wishlist_items);
      this.wishlistItems = data.wishlist_items;
      this.updateWishlistButtons();
    }
  }
  updateWishlistButtons() {
    //console.log('update wishlist buttons');
    this.wishlistButtons = document.querySelectorAll("add-to-wishlist-button");
    Array.from(this.wishlistButtons).map((button) => {
      //console.dir(button);
      const productId = Number(button.dataset.productId);
      this.wishlistItems.map((item) => {
        if (Number(item.Product_ID) === productId) button.updateState("added");
      });
    });
  }
}

const wishlistCollection = new WishlistCollection();
